export default __webpack_public_path__ + "static/media/Avatar-2.5e0b90ca.png";